var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1361 19.4546H22.0754V21.7273H28.1361C28.4575 21.7273 28.7658 21.847 28.9932 22.0601C29.2205 22.2732 29.3482 22.5623 29.3482 22.8637V25.1364H24.4997C23.5356 25.1373 22.6112 25.4967 21.9295 26.1359C21.2477 26.775 20.8643 27.6416 20.8633 28.5455V29.6818C20.8643 30.5857 21.2477 31.4523 21.9295 32.0914C22.6112 32.7306 23.5356 33.09 24.4997 33.0909H31.7724V22.8637C31.7715 21.9598 31.388 21.0932 30.7063 20.4541C30.0245 19.8149 29.1002 19.4555 28.1361 19.4546ZM24.4997 30.8182C24.1782 30.8182 23.8699 30.6985 23.6426 30.4854C23.4153 30.2723 23.2876 29.9832 23.2876 29.6818V28.5455C23.2876 28.2441 23.4153 27.955 23.6426 27.7419C23.8699 27.5288 24.1782 27.4091 24.4997 27.4091H29.3482V30.8182H24.4997Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.526 33.0909H20.8636L13.8506 14H11.513L4.5 33.0909H6.83766L8.81766 27.4759H16.5471L18.526 33.0909ZM9.60896 25.2299L12.5275 16.9524H12.8384L15.7558 25.2299H9.60896Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2046 30.6819C36.3762 30.6819 35.7046 31.3535 35.7046 32.1819C35.7046 33.0103 36.3762 33.6819 37.2046 33.6819V30.6819ZM19.9546 13.4092C19.1262 13.4092 18.4546 14.0807 18.4546 14.9092C18.4546 15.7376 19.1262 16.4092 19.9546 16.4092V13.4092ZM42.25 30.6819H37.2046V33.6819H42.25V30.6819ZM43 29.9289C43 30.3466 42.6624 30.6819 42.25 30.6819V33.6819C44.323 33.6819 46 31.9998 46 29.9289H43ZM43 17.1621V29.9289H46V17.1621H43ZM42.25 16.4092C42.6624 16.4092 43 16.7444 43 17.1621H46C46 15.0913 44.323 13.4092 42.25 13.4092V16.4092ZM19.9546 16.4092H42.25V13.4092H19.9546V16.4092Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextField);
export default __webpack_public_path__ + "static/media/text-field.010145719e2c3ddda5713268258901a1.svg";
export { ForwardRef as ReactComponent };